// Pls run unit test if changes: randomAhaColorUtil.spec.js
import Constants from '@/constant'

const { colors } = Constants

const notSameRedOrGreen = (color1, color2) => {
  const r1 = parseInt(color1.match(/\d+/g)[0], 10)
  const g1 = parseInt(color1.match(/\d+/g)[1], 10)
  const r2 = parseInt(color2.match(/\d+/g)[0], 10)
  const g2 = parseInt(color2.match(/\d+/g)[1], 10)
  const notSimilarRed = r1 !== r2 && (Math.max(r1, r2) - Math.min(r1, r2) > 3)
  return notSimilarRed && g1 !== g2
}

const getArrayRandomAhaColor = (arrayLength) => {
  if (!arrayLength) return []
  const newColors = colors.slice(0, arrayLength)
  const shuffledColors = newColors.sort(() => Math.random() - 0.5)

  const sortedColors = [shuffledColors[0]]

  for (let i = 1; i < shuffledColors.length; i++) {
    let inserted = false
    for (let j = 0; j < sortedColors.length; j++) {
      if (notSameRedOrGreen(sortedColors[j], colors[i])) {
        sortedColors.splice(j + 1, 0, shuffledColors[i])
        inserted = true
        break
      }
    }
    if (!inserted) {
      sortedColors.push(shuffledColors[i])
    }
  }
  return sortedColors
}

export default {
  getArrayRandomAhaColor,
  notSameRedOrGreen, // for unit test
}
